// extracted by mini-css-extract-plugin
export default {"container":"StarRating_container__ylnbS","stars":"StarRating_stars__t5Ls4","rating":"StarRating_rating__RAgOb","reviews":"StarRating_reviews__nFjZ2"};